module.exports = __webpack_public_path__ + "static/img/icon-fangzi@2x.3803e36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-fangzi@2x.png
// module id = /GN4
// module chunks = 1